import { useState, useEffect } from 'react'
import { Button } from '@/shared/components/ui'

// Prompts the user to reload when a new service worker is available.
// Uses the vite-plugin-pwa virtual module, loaded lazily to avoid build issues in tests.
export function PwaUpdatePrompt() {
  const [needRefresh, setNeedRefresh] = useState(false)
  const [updateFn, setUpdateFn] = useState<(() => void) | null>(null)

  useEffect(() => {
    let mounted = true
    // Lazy import the virtual PWA register module (only exists in the built app)
    import('virtual:pwa-register')
      .then(({ registerSW }) => {
        const update = registerSW({
          onNeedRefresh() {
            if (mounted) setNeedRefresh(true)
          },
        })
        if (mounted) setUpdateFn(() => update)
      })
      .catch(() => {
        // PWA not available (e.g. dev or tests) - ignore
      })
    return () => { mounted = false }
  }, [])

  if (!needRefresh) return null

  return (
    <div
      className="fixed bottom-24 left-1/2 z-[60] -translate-x-1/2 px-4"
      role="status"
      aria-live="polite"
    >
      <div className="flex items-center gap-3 rounded-2xl border border-line bg-white px-4 py-3 shadow-card">
        <span className="text-sm font-medium text-navy-900">A new version is available</span>
        <Button variant="accent" size="sm" onClick={() => updateFn?.()}>
          Update
        </Button>
      </div>
    </div>
  )
}
